export const LOAD_DOCUMENTS_LIST = 'assets/LOAD_DOCUMENTS_LIST';
export const DELETE_ASSET = 'assets/DELETE_ASSET';
export const ADD_ASSET = 'assets/ADD_ASSET';
export const DOWNLOAD_ASSET = 'assets/DOWNLOAD_ASSET';
export const DELETE_DOCUMENT = 'assets/DELETE_DOCUMENT';
export const EDIT_ASSET = 'assets/EDIT_ASSET';
export const NOT_RELEVANT_ASSET = 'assets/NOT_RELEVANT_ASSET';
